import styled from "styled-components";

export default styled.div`
  text-transform: uppercase;
  padding-left: 10px;
  color: ${props => (props.isActive ? "inherit" : "#aaa")};
`;
